import React, { useEffect, useState } from 'react'

const GetPixel = ({ orderID, actionType, value }) => {
  const [pixelURL, setPixelURL] = useState('')

  useEffect(() => {
    setPixelURL(
      `${process.env.REACT_APP_API_BASE_URL}/paynow/fast/orders/${orderID}/px?at=${actionType}&val=${value}`
    )
  }, [])

  return <>{pixelURL && <img src={pixelURL} alt="px" />}</>
}

export default GetPixel
